import type { SalesCounters } from '@/api/sales/types'

export type SalesLevelId = 'collection' | 'motive' | 'topicGroup' | 'topic'

export interface SalesLevelDefinition {
  readonly label: string
  readonly description: string
  /** Feldname für die Gridify-Freitextsuche dieser Ebene. */
  readonly nameFilterField: string
}

export const salesLevelIds: readonly SalesLevelId[] = [
  'collection',
  'motive',
  'topicGroup',
  'topic',
] as const

export const salesLevels: Readonly<Record<SalesLevelId, SalesLevelDefinition>> = {
  collection: {
    label: 'Kollektionen',
    description: 'Verkaufszahlen je Motiv-Kollektion.',
    nameFilterField: 'collectionName',
  },
  motive: {
    label: 'Motive',
    description: 'Verkaufszahlen je Motiv.',
    nameFilterField: 'motiveName',
  },
  topicGroup: {
    label: 'Themengruppen',
    description: 'Verkaufszahlen je Slogan-Themengruppe.',
    nameFilterField: 'topicGroupName',
  },
  topic: {
    label: 'Themen',
    description: 'Verkaufszahlen je Slogan-Thema.',
    nameFilterField: 'topicName',
  },
} as const

export function isSalesLevel(value: string): value is SalesLevelId {
  return salesLevelIds.includes(value as SalesLevelId)
}

export const salesSortFields: readonly { value: keyof SalesCounters; label: string }[] = [
  { value: 'salesTotal', label: 'Gesamt' },
  { value: 'sales365', label: '365 Tage' },
  { value: 'sales90', label: '90 Tage' },
  { value: 'sales60', label: '60 Tage' },
  { value: 'sales30', label: '30 Tage' },
  { value: 'sales7', label: '7 Tage' },
]

export function isSalesSortField(value: string): value is keyof SalesCounters {
  return salesSortFields.some((option) => option.value === value)
}
